import React, { useEffect, useState } from "react";
import { Inputs, NavAndTabs, SearchBars } from "../../components";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import SpecialistList from "./specialistList";
import ClinicList from "./clinicList";
import { actionCommon, actionPatient } from "../../redux/actions";
import { useDispatch, useSelector } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { PiBinoculars } from "react-icons/pi";

const BookAnAppointment = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id } = useParams();
    const [activeTab, setActiveTab] = useState(id || "specialist-list");
    const [credentialsClinic, setCredentialsClinic] = useState({
        IsClinicSchedule: false,
        Search: "",
        appDate: new Date().toISOString().split("T")[0],
        appointmentType: 2,
        clinicGuid: null,
        clinicName: "",
        clinic_name: "",
        currency: "EUR",
        doctor_name: "",
        isMale: 0,
        languageId: [],
        physicianService: [],
        serviceName: [],
        userTimeZone: "India Standard Time",
        userType: 2,
    });
    const [credentialsSpecialist, setCredentialsSpecialist] = useState({
        IsClinicSchedule: false,
        IsOnlineAppointment: false,
        LanguageIds: 1,
        Search: "",
        appDate: new Date().toISOString().split("T")[0],
        appointmentType: 2,
        clinicGuid: null,
        clinicName: "",
        clinic_name: "",
        currency: "EUR",
        doctor_name: "",
        isMale: 0,
        languageId: [],
        physicianService: [],
        serviceName: [],
        userTimeZone: "India Standard Time",
        userType: 2,
    });
    const [date, setDate] = useState();
    const [options1, setOptions1] = useState([]);
    const [options2, setOptions2] = useState([]);
    const [options3, setOptions3] = useState([]);
    const [options4, setOptions4] = useState([]);

    const [selectedLocation1, setSelectedLocation1] = useState([]);
    const [selectedPhysicianServices2, setSelectedPhysicianServices2] = useState([]);
    const [selectedLanguages3, setSelectedLanguages3] = useState([]);
    const [selectedIsMale4, setSelecteIsMale4] = useState([]);
    const [search, setSearch] = useState("");


    const handleDateChange = (date) => {
        const formattedDate = new Date(date).toISOString().split("T")[0];

        if (activeTab === "specialist-list") {
            setCredentialsSpecialist((prev) => ({
                ...prev,
                appDate: formattedDate,
            }));
        } else if (activeTab === "clinics-list") {
            setCredentialsClinic((prev) => ({
                ...prev,
                appDate: formattedDate,
            }));
        }
    };

    const handleChange = (type, value) => {
        switch (type) {
            case "search":
                setSearch(value);
                break;
            case "location":
                setSelectedPhysicianServices2(value);
                break;
            case "physicianService":
                setSelectedPhysicianServices2(value);
                break;
            case "languageId":
                setSelectedLanguages3(value);
                break;
            case "isMale":
                setSelecteIsMale4(value);
                break;
            default:
                break;
        }
    };

    useEffect(() => {
        dispatch(actionCommon.getPhysicianService(1));
        dispatch(actionCommon.getLanguages());
        dispatch(actionPatient.getLocation());
    }, [dispatch]);

    const getLocationData = useSelector(
        (state) => state.patient.getLocationData?.data
    );
    const getLanguagesData = useSelector(
        (state) => state.common.getLanguagesData?.data
    );

    const getPhysicianServiceData = useSelector(
        (state) => state.common.getPhysicianServiceData?.data
    )

    useEffect(() => {
        if (getLocationData) {
            const newOptions = getLocationData?.result.map((location) => ({
                value: location,
                label: location,
            }));

            setOptions1(newOptions);
        }
    }, [getLocationData]);

    useEffect(() => {
        if (getLanguagesData) {
            const newOptions = getLanguagesData.result
                .filter((item) => item.isWebsiteLanguage)
                .map((item) => ({
                    value: item.languageId,
                    label: item.languageName,
                    abb: item.languageAbbreviation,
                }));

            setOptions3(newOptions);
        }
    }, [getLanguagesData]);

    useEffect(() => {
        if (getPhysicianServiceData) {
            const newOption = getPhysicianServiceData.result.map((item) => ({
                value: item.isPhysicianServiceId,
                label: item.physicianServiceName,
            }));
            setOptions2(newOption);
        }
    }, [getPhysicianServiceData]);

    useEffect(() => {
        const newOption = [
            {
                value: 1,
                label: t("Male"),
            },
            {
                value: 2,
                label: t("Female"),
            },
            {
                value: 3,
                label: t("Other"),
            },
        ];
        setOptions4(newOption);
    }, [t]);

    const onTabChange = (tabId) => {
        setActiveTab(tabId);
        navigate(`/book-an-appointment/${tabId}`);
    };

    const onSearchClick = () => {
        console.log("onSearchClick");
    };


    const radioAndSearch = (
        <>
            <Row className="exado-row">
                <Col className="exado-col">
                    {id === "specialist-list" && (
                        <div className="exado-radio-blk">
                            <Inputs.CheckRadioInput
                                type="radio"
                                label={t("book_an_appointments.in_clinic")}
                                name="IsOnlineAppointment"
                                className="form-grp-radio"
                                checked={!credentialsSpecialist.IsOnlineAppointment}
                                onChange={() =>
                                    setCredentialsSpecialist({ ...credentialsSpecialist, IsOnlineAppointment: false })
                                }
                            />
                            <Inputs.CheckRadioInput
                                type="radio"
                                label={t("book_an_appointments.online")}
                                name="IsOnlineAppointment"
                                className="form-grp-radio"
                                checked={credentialsSpecialist.IsOnlineAppointment}
                                onChange={() =>
                                    setCredentialsSpecialist({ ...credentialsSpecialist, IsOnlineAppointment: true })
                                }
                            />
                        </div>
                    )}

                    <SearchBars.SearchBar
                        className="search-bar"
                        showDate={true}
                        showSelect1={true}
                        showSelect2={true}
                        showSelect3={true}
                        showSelect4={activeTab === "specialist-list" ? true : false}
                        datepickermd={3}
                        selectColmd1={3}
                        selectColmd2={3}
                        selectColmd3={3}
                        selectColmd4={3}
                        searchColmd={activeTab === "specialist-list" ? 7 : 10}
                        buttonColmd={2}
                        datepickerxs={6}
                        selectColxs1={6}
                        selectColxs2={6}
                        selectColxs3={6}
                        selectColxs4={6}
                        selectColxs={6}
                        buttonColxs={12}
                        cDateRangeClassname="custom-date-range-picker text-uppercase"
                        buttonClassname="btn-solid-Aqua_Teal w-100"
                        searchGrpClassName="form-group1 text-uppercase"
                        select1Classname="select3 text-uppercase"
                        select2Classname="select3 text-uppercase"
                        select3Classname="select3 text-uppercase"
                        select4Classname="select3 text-uppercase"
                        classNameCol5="mt-md-4"
                        classNameCol6="mt-md-4"
                        classNameCol7="mt-md-4"
                        isMulti2={true}
                        isMulti3={true}
                        select1Options={options1}
                        select2Options={options2}
                        select3Options={options3}
                        select4Options={options4}
                        searchPlaceholder={t("Search")}
                        select1Placeholder={t("location")}
                        select2Placeholder={t("specialities")}
                        select3Placeholder={t("Language")}
                        select4Placeholder={t("Gender")}
                        cDateRangePlaceholder={t("enter") + " " + t("date")}
                        buttonChildren={<PiBinoculars className="bionCularIcon" />}
                        dateRange={date}
                        // searchValue={search}
                        select1Value={selectedLocation1}
                        select2Value={selectedPhysicianServices2}
                        select3Value={selectedLanguages3}
                        onDateRangeChange={handleDateChange}
                        onLocationChange={(selected) => handleChange("location", selected)}
                        onClinicChange={(selected) =>
                            handleChange("physicianService", selected)
                        }
                        onChange3={(selected) => handleChange("languageId", selected)}
                        onChange4={(selected) => handleChange("isMale", selected)}
                        onSearchChange={(e) => handleChange("search", e.target.value)}
                        onSearchClick={() => onSearchClick()}
                    />
                </Col>
            </Row>

        </>
    );


    const tabs = [
        {
            id: "clinics-list",
            label: t("clinics_list"),
            content: <ClinicList radioAndSearch={radioAndSearch} activeTab={activeTab} credentialsClinic={credentialsClinic} setCredentialsClinic={setCredentialsClinic} />,
            disabled: false,
        },
        {
            id: "specialist-list",
            label: `${t("specialist_list")}`,
            content: <SpecialistList radioAndSearch={radioAndSearch} activeTab={activeTab} credentialsSpecialist={credentialsSpecialist} setCredentialsSpecialist={setCredentialsSpecialist} />,
            disabled: false,
        },
    ];
    return (
        <NavAndTabs.NavAndTabs
            tabs={tabs}
            activeTab={activeTab}
            onTabChange={onTabChange}
        />
    );
};

export default BookAnAppointment;
